/*
 * GENERATED by scripts/gen-spec-anchors.mjs — DO NOT EDIT BY HAND.
 * Run `npm run gen:anchors` to regenerate after a spec heading changes.
 *
 * Maps a spec-ref doc key (roman numeral, or "DESIGN") + section number to the
 * repo-relative file and the GitHub heading anchor that lands on that section.
 */

export interface SpecDocIndex {
  /** Repo-relative path, e.g. "parts/part-iv-transport-plane.md". */
  readonly file: string;
  /** section number ("27", "27.3") → GitHub heading anchor slug. */
  readonly anchors: Readonly<Record<string, string>>;
}

export const SPEC_ANCHORS: Readonly<Record<string, SpecDocIndex>> = {
  "III": {
    "file": "parts/part-iii-trust-plane.md",
    "anchors": {
      "15": "15-pki-hierarchy-and-root-authority",
      "16": "16-member-registry--transparency-log",
      "17": "17-enrolment-protocol",
      "18": "18-certificate-format--signing-profile",
      "19": "19-revocation-and-rotation",
      "20": "20-federation-primitive-cross-signing--trust-manifest",
      "21": "21-trust-plane-api-surface",
      "22": "22-operational-profile",
      "23": "23-forward-references--coupling-with-other-planes",
      "15.1": "151-two-tier-hierarchy",
      "15.1.1": "1511-implementation-split-step-ca--mesh-internal-services",
      "15.1.2": "1512-two-parallel-issuing-cas-corporate--natural-person",
      "15.2": "152-cryptographic-algorithms",
      "15.3": "153-validity-periods",
      "15.4": "154-naming-convention",
      "15.4.1": "1541-member-organisation-cert",
      "15.4.2": "1542-service-cert",
      "15.5": "155-certificate-extensions",
      "15.6": "156-post-quantum-trajectory",
      "16.1": "161-storage-model",
      "16.1.1": "1611-hash-invariant-validation",
      "16.1.2": "1612-genesis-row",
      "16.1.3": "1613-member-auth-secrets-planned",
      "16.2": "162-transparency-log-construction",
      "16.2.1": "1621-canonical-leaf-serialisation",
      "16.2.2": "1622-inclusion-and-consistency-proofs",
      "16.3": "163-daily-anchor-publication",
      "16.3.1": "1631-job-steps",
      "16.3.2": "1632-failure--backfill-semantics",
      "16.3.3": "1633-anchor-payload-canonical-json",
      "16.4": "164-log-query-api",
      "16.5": "165-witness-network-fork-detection",
      "17.1": "171-roles",
      "17.2": "172-sequence",
      "17.2.1": "1721-csr-acceptance-criteria",
      "17.3": "173-authorisation-token-format",
      "17.4": "174-failure-modes",
      "17.5": "175-sponsor-key-bootstrap--rotation",
      "17.5.1": "1751-sponsor-key-rotation",
      "17.5.2": "1752-sponsor-key-compromise",
      "17.6": "176-enrolment-timing-budget",
      "17.7": "177-threat-model--operator-insider",
      "17.7.1": "1771-schema-invariants-for-replication-portable-witness",
      "17.7.2": "1772-major-version-upgrade-ceremony",
      "17.7.3": "1773-required-postgresql-operational-settings-tier-b",
      "17.7.4": "1774-slot-invalidation-recovery",
      "17.7.5": "1775-wal-archive-bucket-spec",
      "17.7.6": "1776-application-layer-write-contract",
      "17.7.7": "1777-startup-integrity-check",
      "19.1": "191-revocation-methods",
      "19.1.1": "1911-delegated-ocsp-responder",
      "19.1.2": "1912-ocsp-profile",
      "19.1.3": "1913-crl-profile",
      "19.1.4": "1914-revocation-cache-ttl-by-reason",
      "19.2": "192-revocation-reasons",
      "19.3": "193-rotation-protocol",
      "19.3.1": "1931-rotation_proof_jws-structure",
      "19.3.2": "1932-retire-authorisation",
      "19.4": "194-issuing-ca-rotation",
      "19.4.1": "1941-rolling-rotation-enforcement",
      "19.4.2": "1942-unplanned-compromise-recovery",
      "20.1": "201-establishing-a-federation",
      "20.2": "202-cross-cert-format",
      "20.3": "203-trust-manifest",
      "20.4": "204-per-request-federation-enforcement",
      "20.5": "205-mutual-audit-chaining",
      "20.5.1": "2051-failure-semantics",
      "20.5.2": "2052-auditor-verification",
      "20.6": "206-federation-revocation",
      "20.6.1": "2061-trust-store-invalidation-channel",
      "21.1": "211-openapi-excerpt",
      "21.2": "212-authentication-summary",
      "21.3": "213-rate-limits",
      "22.1": "221-hsm-requirements",
      "22.2": "222-backup--restore",
      "22.3": "223-disaster-recovery-objectives",
      "22.4": "224-witness-register",
      "22.4.1": "2241-register-provenance-normative-wire-protocol",
      "22.5": "225-ceremonies",
      "22.6": "226-pre-pilot-prerequisites",
      "22.7": "227-compromise-recovery-playbook",
      "23.1": "231-coupling-with-the-transport-plane-part-iv",
      "23.2": "232-coupling-with-the-catalog-plane-part-v",
      "23.3": "233-coupling-with-the-consent-plane-part-vii"
    }
  },
  "IV": {
    "file": "parts/part-iv-transport-plane.md",
    "anchors": {
      "24": "24-sidecar-architecture",
      "25": "25-message-envelope--wire-format",
      "26": "26-rfc-9421-signature-profile",
      "27": "27-replay-protection--idempotency",
      "28": "28-store-and-forward-with-nats-jetstream",
      "29": "29-circuit-breaker-rate-limiting-retry",
      "30": "30-federation-routing",
      "31": "31-transport-plane-api-surface",
      "24.1": "241-process-model",
      "24.2": "242-components",
      "24.3": "243-ports",
      "24.4": "244-configuration-surface",
      "24.4.1": "2441-tls-13-hardening",
      "24.5": "245-liveness-readiness-startup",
      "25.1": "251-egress-request-from-local-application",
      "25.2": "252-mesh-wire-request-sidecar--peer-sidecar",
      "25.2.1": "2521-header-semantics",
      "25.2.1.1": "25211-header-value-length-limits",
      "25.2.2": "2522-response-envelope",
      "25.3": "253-cloudevents-asynchronous-flows",
      "25.4": "254-maximum-sizes",
      "26.1": "261-signature-components",
      "26.2": "262-signature-parameters",
      "26.2.1": "2621-test-vectors-conformance",
      "26.3": "263-verification-procedure",
      "26.5": "265-clock-skew-tolerance-and-ntp-failure",
      "26.4": "264-signature-key-resolution",
      "26.4.1": "2641-in-mesh",
      "26.4.2": "2642-cross-mesh",
      "26.4.3": "2643-peer-key-freshness-vs-registry-refresh",
      "26.4.4": "2644-trust-plane-api-surface-addition-part-iii-2111",
      "27.1": "271-replay-window",
      "27.2": "272-idempotency-cache",
      "27.3": "273-nonce-burns",
      "27.4": "274-storage-failure-mode",
      "27.4.1": "2741-dev-mode-override",
      "28.1": "281-why-store-and-forward",
      "28.2": "282-stream-and-subject-layout",
      "28.3": "283-enqueue-path",
      "28.4": "284-delivery-worker",
      "28.4.2": "2842-deadletter-handling",
      "28.4.1": "2841-application-notification-of-disposition",
      "28.4.3": "2843-worker-process-model",
      "28.4.4": "2844-delivery-target-resolution-peer-registry",
      "28.5": "285-cert-lifecycle--store-and-forward",
      "28.5.1": "2851-revocation",
      "28.5.2": "2852-rotation-planned",
      "28.5.3": "2853-expiration",
      "28.5.4": "2854-network-split--retry",
      "28.6": "286-at-most-once-vs-at-least-once",
      "28.7": "287-crash-recovery",
      "29.1": "291-per-target-circuit-breaker",
      "29.2": "292-rate-limiting",
      "29.3": "293-retry-policy-on-the-sender",
      "30.1": "301-cross-mesh-request-dispatch",
      "30.2": "302-cross-mesh-response",
      "30.3": "303-audit-chain-symmetry-across-mesh-boundary",
      "30.4": "304-discovery-freshness",
      "30.5": "305-trust-event-subscription-topology",
      "31.1": "311-openapi-excerpt--egress-loopback-only",
      "31.2": "312-openapi-excerpt--ingress-mtls",
      "31.3": "313-observability-surface"
    }
  },
  "V": {
    "file": "parts/part-v-catalog-plane.md",
    "anchors": {
      "32": "32-openapi-31--asyncapi-30-publication",
      "33": "33-versioning--breaking-change-detection",
      "34": "34-pact-contract-testing",
      "35": "35-search-discovery-public-mirror",
      "36": "36-catalog-plane-api-surface",
      "32.1": "321-why-a-catalogue",
      "32.2": "322-what-is-published",
      "32.3": "323-service-publication-unit",
      "32.3.1": "3231-signed-payload--exact-construction",
      "32.3.2": "3232-key-continuity-across-major-versions",
      "32.3.3": "3233-signed-scope-checklist",
      "32.4": "324-storage-model",
      "32.5": "325-publication-flow",
      "32.5.1": "3251-spectral-mesh-ruleset1",
      "32.5.2": "3252-verification-evidence-long-lived-audit-independence",
      "32.5.3": "3253-trust-plane-merkle-anchoring",
      "32.6": "326-openapi-31-conformance-constraints",
      "32.6.0": "3260-why-31-and-not-32",
      "32.6.1": "3261-version-bump-trigger",
      "32.6.2": "3262-acceptance-constraints",
      "32.7": "327-asyncapi-30-conformance-constraints",
      "33.1": "331-semver-applied",
      "33.2": "332-breaking-change-detector",
      "33.3": "333-what-breaking-means",
      "33.3.1": "3331-enum-extensibility",
      "33.3.2": "3332-json-schema-2020-12-features-beyond-oasdiff-coverage",
      "33.3.3": "3333-oasdiff-integration",
      "33.4": "334-deprecation-and-sunset",
      "33.4.1": "3341-emergency-security-sunset",
      "34.1": "341-why-contracts-are-gated",
      "34.2": "342-consumer-contracts",
      "34.2.1": "3421-acceptance-constraints-defends-against-self-fulfilling-pacts",
      "34.3": "343-provider-verification-flow",
      "34.4": "344-the-mesh-contract-test",
      "34.5": "345-contract-drift-handling",
      "35.1": "351-discovery-api",
      "35.2": "352-catalog-browser",
      "35.3": "353-public-mirror",
      "35.3.1": "3531-audit-verification-path",
      "35.4": "354-cross-mesh-discovery",
      "35.4.1": "3541-signed-response-envelope",
      "36.1": "361-rate-limits-and-request-size-limits",
      "36.2": "362-caching",
      "36.3": "363-lifecycle-deletion-tombstoning",
      "36.3.1": "3631-release-channels",
      "36.3.2": "3632-deletion",
      "36.3.3": "3633-pact-tombstoning-when-a-consumer-is-revoked",
      "36.3.4": "3634-pact-amendment",
      "36.3.5": "3635-anti-typosquatting-on-service-ids"
    }
  },
  "VI": {
    "file": "parts/part-vi-observability-plane.md",
    "anchors": {
      "37": "37-opentelemetry-semantic-conventions-for-mesh",
      "38": "38-audit-event-format--hash-chaining",
      "39": "39-verification-cli--replay-protocol",
      "40": "40-archival-to-immutable-storage",
      "41": "41-provisioned-dashboards",
      "37.1": "371-why-a-defined-namespace",
      "37.2": "372-resource-level-attributes",
      "37.3": "373-span-attributes-for-mesh-requests",
      "37.4": "374-why-citizen-identifiers-are-pseudonymised",
      "37.5": "375-tracing-context-propagation",
      "37.6": "376-error-kind-taxonomy",
      "37.7": "377-metric-naming-and-prometheus-mapping",
      "38.1": "381-audit-plane-vs-trust-plane-log",
      "38.2": "382-event-format",
      "38.3": "383-self-hash-construction",
      "38.3.1": "3831-self-hash-preimage",
      "38.3.2": "3832-merkle-leaf-bytes",
      "38.3.3": "3833-event_kind_id-mapping-never-renumber-only-append",
      "38.3.4": "3834-genesis-boundary-country-bound",
      "38.4": "384-append-flow",
      "38.4.1": "3841-two-pass-append-protocol",
      "38.4.2": "3842-audit-emitter-role-registration",
      "38.4.3": "3843-audit-first-discipline--degraded-mode-ladder",
      "38.5": "385-hourly-merkle-tree",
      "38.5.1": "3851-witness-pull-side-coverage",
      "38.5.2": "3852-verification-path",
      "38.6": "386-hmac-with-erasable-key-forgetting-protocol",
      "38.6.1": "3861-forgetting-service",
      "38.6.2": "3862-erasure-flow",
      "38.6.3": "3863-forensic-exception-court-order",
      "39.1": "391-mesh-cli-audit-verify",
      "39.2": "392-replay-re-derivation",
      "39.3": "393-investigative-queries",
      "39.3.1": "3931-authorisation-policy",
      "39.3.2": "3932-rate-limits-and-watch-the-watchers-public-dashboard",
      "40.1": "401-two-tier-storage-immutable-no-loki",
      "40.1.1": "4011-migration",
      "40.2": "402-data-classification--per-class-buckets",
      "40.2.1": "4021-normative-data-class-registry",
      "40.2.2": "4022-per-cloud-retention-strategy",
      "40.2.3": "4023-backend-feature-parity-cross-cloud-non-equivalence",
      "40.3": "403-object-format",
      "40.4": "404-archive-integrity-sweep",
      "41.1": "411-dashboard-set",
      "41.2": "412-alerting",
      "41.3": "413-dashboard-as-code",
      "41.4": "414-citizen-facing-transparency"
    }
  },
  "VII": {
    "file": "parts/part-vii-consent-plane.md",
    "anchors": {
      "42": "42-consent-record-schema",
      "43": "43-ledger-storage--hash-chaining",
      "44": "44-ussd-flow-protocol",
      "45": "45-sms-notifications",
      "46": "46-eidas-20-sd-jwt-ready-wallet-format",
      "47": "47-citizen-self-service--right-to-be-forgotten",
      "42.1": "421-what-a-consent-record-represents",
      "42.2": "422-the-consent-record--canonical-structure",
      "42.3": "423-field-semantics",
      "42.3.1": "4231-channel--lawful-basis-constraint-matrix",
      "42.4": "424-pseudonym-strategy",
      "42.4.1": "4241-identity-input-registry",
      "42.4.2": "4242-residual-cryptographic-risk-acknowledged",
      "42.4.3": "4243-re-pseudonymisation-ceremony",
      "42.4.4": "4244-cross-mesh-pseudonyms-via-federation-key-ceremony",
      "43.1": "431-storage-model",
      "43.2": "432-hash-chain-construction",
      "43.2.1": "4321-operator-read-surface-console-facing",
      "43.3": "433-lookup-semantics--reservation-token-protocol",
      "43.3.1": "4331-post-v1consentsconsent_idcheck",
      "43.3.2": "4332-sidecar-use-of-usage_token",
      "43.3.3": "4333-caching-constraints",
      "43.4": "434-settlement-and-refund",
      "43.4.1": "4341-reservation-expiry",
      "43.4.2": "4342-the-race-is-closed",
      "44.1": "441-why-ussd-is-first-class",
      "44.1.1": "4411-msisdn--identity-binding-anti-fraud",
      "44.1.2": "4412-self-service-revocation-cannot-reset-the-pin-via-sms",
      "44.2": "442-ussd-session-flow",
      "44.3": "443-ussd-consent-code",
      "44.3.1": "4431-consent-code-generation-constraints",
      "44.4": "444-ussd-session-api-consent-plane--aggregator",
      "44.4.1": "4441-session-timing",
      "44.4.2": "4442-idempotency-and-degraded-recovery",
      "44.4.3": "4443-msisdn-normalisation",
      "44.4.4": "4444-authentication-threat-model",
      "44.5": "445-ussd-specific-privacy-posture",
      "45.1": "451-why-sms",
      "45.2": "452-notification-kinds",
      "45.3": "453-multilingual-notifications",
      "45.4": "454-volume-control",
      "45.4.1": "4541-anti-flood-for-hard-exempt-notifications",
      "45.5": "455-sms-gateway-adapters",
      "46.1": "461-why-wallet-readiness",
      "46.1.1": "4611-architectural-placement-of-openid4vp",
      "46.2": "462-sd-jwt-vc-export",
      "46.3": "463-openid4vp-integration-consumer-agency-app-side",
      "46.4": "464-what-the-mvp-ships",
      "46.5": "465-issuer-discovery--jwks",
      "47.1": "471-self-service-portal",
      "47.2": "472-authentication-for-self-service",
      "47.3": "473-right-to-be-forgotten-rtbf-flow",
      "47.3.1": "4731-propagation-latency-target",
      "47.3.1.1": "47311-non-compliance-detection",
      "47.3.1.2": "47312-sampling-based-verification",
      "47.3.2": "4732-what-the-citizen-gets",
      "47.4": "474-what-rtbf-does-not-erase",
      "47.5": "475-audit--investigation-of-self-service-operations"
    }
  },
  "VIII": {
    "file": "parts/part-viii-integration.md",
    "anchors": {
      "48": "48-smartlink-integration-mesh-connector",
      "49": "49-federation-e2e-scenario--lesotho--south-africa",
      "50": "50-cli--runbooks",
      "51": "51-deployment-topology--benchmarks",
      "52": "52-acceptance-criteria--executable-evidence",
      "48.1": "481-why-smartlink-integrates",
      "48.2": "482-the-mesh-connector-type",
      "48.3": "483-runtime-dispatch",
      "48.4": "484-proof-mode-mapping",
      "48.5": "485-consent-resolution-at-runtime",
      "48.6": "486-auto-publication-to-catalog",
      "48.7": "487-audit-on-the-smartlink-side",
      "48.8": "488-what-this-means-for-the-existing-eregistrations-stack",
      "49.1": "491-the-scenario",
      "49.2": "492-step-by-step",
      "49.3": "493-what-this-scenario-demonstrates-politically",
      "49.4": "494-what-this-scenario-demonstrates-technically",
      "49.5": "495-intra-mesh-single-mesh-variant-somalia-pilot",
      "50.1": "501-mesh-cli--the-operator-surface",
      "50.1.1": "5011-trust-plane-commands",
      "50.1.2": "5012-catalog-plane-commands",
      "50.1.3": "5013-audit-plane-commands",
      "50.1.4": "5014-consent-plane-commands",
      "50.1.5": "5015-sidecar-commands",
      "50.1.6": "5016-orchestration-commands",
      "50.2": "502-runbooks",
      "51.0": "510-mvpproduction-hardening-checklist",
      "51.1": "511-docker-compose-layout",
      "51.2": "512-bootstrap-script",
      "51.3": "513-benchmarks-acceptance-gates",
      "51.4": "514-phase-2-roadmap-post-pilot",
      "52.1": "521-the-acceptance-bar",
      "52.2": "522-acceptance-criteria",
      "52.3": "523-acceptance-evidence-bundle",
      "52.4": "524-what-passing-means-in-spirit",
      "52.5": "525-sign-off",
      "52.6": "526-the-operator-cockpit-tier-model-normative"
    }
  },
  "DESIGN": {
    "file": "docs/superpowers/specs/2026-06-23-mesh-no-code-provisioning-design.md",
    "anchors": {
      "1": "1-summary",
      "2": "2-locked-decisions-from-brainstorming-2026-06-23",
      "3": "3-non-negotiable-constraints",
      "4": "4-architecture-overview",
      "5": "5-what-already-exists-build-on-dont-rebuild",
      "6": "6-component-1--the-declarative-provisioner",
      "7": "7-component-2--the-five-planes-serving-real-data",
      "8": "8-component-3--the-tiered-operator-cockpit",
      "9": "9-component-4--the-iterative-orchestration-workflow-the-engine",
      "10": "10-the-done-gate--the-live-intra-mesh-step-9-exchange",
      "11": "11-the-somalia-manifest-stage-2-input",
      "12": "12-new-acs-traceability-spec-bumps",
      "13": "13-scope-guard-what-we-are-not-building-now",
      "14": "14-risks-objections-dialecticalreview-and-resolutions",
      "15": "15-definition-of-done-for-the-staged-delivery",
      "6.1": "61-mesh-nodeyaml--the-declaregeneratepin-firewall",
      "6.2": "62-the-render-target-the-existing-env-contract",
      "6.3": "63-verbs",
      "8.1": "81-the-tiers",
      "8.2": "82-properties",
      "8.3": "83-net-new-surface-flagged"
    }
  }
} as const;
